import { defineStore } from 'pinia';
import { ref, reactive } from '@nuxtjs/composition-api';
import { PRISE_WITH_SUBSCRIPTION_FILTERS } from '@/constants/Filters'

export const useSearchStore = defineStore('searchStore', () => {
  const rawConfigurations = new Map();
  const rawFilters = {}
  const booleanFilters = ['fiveGCapable']
  const categoryFilters = ['categoryIDReferences', 'fits_with']
  const activeCategorySlug = ref('')


  const mobilePhonesSearchConfiguration = {
    searchableFields: ['filterColorOptions', 'brandName', 'storageOptions', 'fiveGCapable'],
    aggregations: {
      brandName: { title: 'Brand', size: 200, conjunction: false, sort: ['key'], order: 'asc' },
      filterColorOptions: { title: 'Farver', size: 10, conjunction: false, sort: ['key'], order: 'asc' },
      screenSizeOptions: { title: 'Skærmstørrelser', size: 10, conjunction: false, sort: ['key'], order: 'asc' },
      fiveGCapable: { title: '5G', size: 10, conjunction: true, sort: ['key'], order: 'asc' },
      priceWithSubscriptionFilter: { title: 'Kontantpris', conjunction: false, sort: ['key'], order: 'asc' }
    },
    customFilters: {
      fiveGCapable: (item) => {
        return item.fiveGCapable === true;
      }
    }
  }

  const tabletsSearchConfiguration = {
    searchableFields: ['brandName', 'storageOptions'],
    sortings: {
      name_asc: {
        field: 'name',
        order: 'asc'
      }
    },
    aggregations: {
      brandName: { title: 'Brand', size: 200, conjunction: false },
      storageOptions: { title: 'Størrelse', size: 10, conjunction: false }
    }
  }

  const accessoriesSearchConfiguration = {
    searchableFields: ['categoryIDReferences', 'fits_with'],
    sortings: {
      name_asc: {
        field: 'name',
        order: 'asc'
      }
    },
    aggregations: {
      categoryIDReferences: { title: 'Kategori', size: 200, conjunction: false, sort: ['key'], order: 'aspasserTilc' },
      fits_with: { title: 'Passer til', size: 200, conjunction: false, sort: ['key'], order: 'asc' }
    }
  }

  rawConfigurations.set('mobiltelefonerny', mobilePhonesSearchConfiguration);
  rawConfigurations.set('mobiltelefoner', mobilePhonesSearchConfiguration);
  rawConfigurations.set('tilbehoer', accessoriesSearchConfiguration);
  rawConfigurations.set('tablets', tabletsSearchConfiguration);

  const configurations = ref(rawConfigurations);


  Object.keys(mobilePhonesSearchConfiguration.aggregations).forEach(aggregation => {
    rawFilters[aggregation] = []
  })

  Object.keys(tabletsSearchConfiguration.aggregations).forEach(aggregation => {
    rawFilters[aggregation] = []
  })

  Object.keys(accessoriesSearchConfiguration.aggregations).forEach(aggregation => {
    rawFilters[aggregation] = []
  })

  const state = reactive({
    searchFilters: rawFilters
  })

  const itemSearchResult = ref({})
  const query = ref('')
  const listToFilter = ref([]);

  const fitsWith = ref(null)

  /**
   * Temporary data manipulation that adds the fits_with/passerTil attribute to the list data
   * so that it can be correctly filtered
   * @todo delete this and get the correctly formatted list from endpoint/backend instead
   */
  const transformDataForAccessories = (productListFamily, categoryTree) => {
    fitsWith.value = categoryTree.find(category => (category.key === 'Fits_with'))
    productListFamily.forEach(item => {
      item.fits_with = []

      const addIdRef = child => {
        const childFitsId = item.categoryIDReferences.find(catRef => catRef === child.id)

        if (childFitsId) {
          item.fits_with = [...item.fits_with, childFitsId]
        }
        child.children.forEach(addIdRef)
      }

      fitsWith.value.children.forEach(addIdRef)

      return item
    })
  }


  // eslint-disable-next-line complexity
  const getPriceFilterKey = (priceWithoutSubscription) => {
    let key = ''
    if (priceWithoutSubscription >= 0 && priceWithoutSubscription <= 4000) {
      key = PRISE_WITH_SUBSCRIPTION_FILTERS[0]
    } else if (priceWithoutSubscription >= 4000 && priceWithoutSubscription <= 6000) {
      key = PRISE_WITH_SUBSCRIPTION_FILTERS[1]
    } else if (priceWithoutSubscription >= 6000 && priceWithoutSubscription <= 8000) {
      key = PRISE_WITH_SUBSCRIPTION_FILTERS[2]
    } else {
      key = PRISE_WITH_SUBSCRIPTION_FILTERS[3]
    }
    return key
  }

  const priceWithSubscriptionFiltering = (productListFamily) => {
    productListFamily.forEach(item => {
      const priceWithoutSubscription = item.masterVariantPricingDetails?.productWithSubscriptionPrice
      if (!priceWithoutSubscription) {
        return
      }

      item.priceWithSubscriptionFilter = getPriceFilterKey(priceWithoutSubscription)
    })
  }

  return {
    transformDataForAccessories,
    priceWithSubscriptionFiltering,
    rawFilters,
    fitsWith,
    booleanFilters,
    categoryFilters,
    configurations,
    itemSearchResult,
    query,
    listToFilter,
    state,
    activeCategorySlug
  }
})
